export const ALL_SECTIONS = [
  'overview','devices','clients','firmware','inventory','invoices',
  'finance','tickets','calendar','pipeline','goals','tools',
  'notifications','audit','users','system'
]

export const SECTIONS_META = [
  { key: 'overview', label: 'Overview' },
  { key: 'devices', label: 'Dispositivos' },
  { key: 'clients', label: 'Clientes' },
  { key: 'firmware', label: 'Firmware' },
  { key: 'inventory', label: 'Inventario' },
  { key: 'invoices', label: 'Facturación' },
  { key: 'finance', label: 'Finanzas' },
  { key: 'tickets', label: 'Soporte' },
  { key: 'calendar', label: 'Calendario' },
  { key: 'pipeline', label: 'Pipeline' },
  { key: 'goals', label: 'Metas' },
  { key: 'tools', label: 'Herramientas' },
  { key: 'notifications', label: 'Notificaciones' },
  { key: 'audit', label: 'Auditoría' },
  { key: 'users', label: 'Usuarios Admin' },
  { key: 'system', label: 'Sistema' },
]

export const ROLE_DEFAULTS = {
  superadmin: ALL_SECTIONS,
  admin:      ALL_SECTIONS,
  soporte:    ['overview', 'clients', 'tickets', 'calendar', 'devices'],
  ventas:     ['overview', 'clients', 'pipeline', 'invoices', 'finance', 'goals', 'calendar'],
  viewer:     ['overview', 'devices', 'clients'],
  reseller:   ['reseller-portal'],
}

/**
 * Merge default permissions from multiple roles into a single deduplicated array.
 * @param {string[]} roles - Array of role keys (e.g. ['admin', 'reseller'])
 * @returns {string[]} Merged permissions
 */
export function mergeRolePermissions(roles) {
  const perms = new Set()
  for (const role of roles) {
    const defaults = ROLE_DEFAULTS[role] || ROLE_DEFAULTS.admin
    for (const p of defaults) perms.add(p)
  }
  return [...perms]
}
